import { Button } from "@mui/joy";
import { useEffect, useState } from "react";
import {
  loadTossPayments,
  TossPaymentsPayment,
} from "@tosspayments/tosspayments-sdk";
import { v4 as uuidv4 } from "uuid";
import { trackCapiStandardEvent } from "analytics/metaCapi";
import { useNavigate } from "react-router-dom";
import { PATH } from "routes/paths";

export default function PaymentButtonV5() {
  const tossPaymentsClientKey = process.env.REACT_APP_TOSSPAYMENTS_CLIENT_KEY!!;

  const navigate = useNavigate();
  const [tossPaymentsPayment, setTossPaymentsPayment] =
    useState<TossPaymentsPayment | null>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const buttonText = "결제하기";

  async function requestTossPayments() {
    if (tossPaymentsPayment) {
      try {
        await tossPaymentsPayment?.requestPayment({
          method: "CARD",
          amount: {
            currency: "KRW",
            value: 395000,
          },
          orderId: uuidv4(),
          orderName: `디스턴싱 프로그램 / 100일`,
          customerEmail: "",
          customerName: "",
          successUrl: window.location.origin + PATH.v5TosspaymentsSuccess,
          failUrl: window.location.origin + PATH.v5Product,
          card: {
            useEscrow: false,
            flowMode: "DEFAULT",
            useCardPoint: false,
            useAppCardOnly: false,
          },
        });
      } catch (error) {
        // 에러 처리하기
        console.error(error);
      }
    }
  }

  useEffect(() => {
    async function fetchTossPaymentsPayment() {
      if (tossPaymentsClientKey) {
        const tossPayments = await loadTossPayments(tossPaymentsClientKey);
        const payment = tossPayments.payment({
          customerKey: `ck_${uuidv4()}`,
        });

        setTossPaymentsPayment(payment);
      }
    }

    fetchTossPaymentsPayment();
  }, [tossPaymentsClientKey]);

  const handlePaymentRequest = () => {
    trackCapiStandardEvent(
      "InitiateCheckout",
      {
        value: 59000,
        currency: "KRW",
      },
      undefined,
      "v5"
    );

    requestTossPayments();
  };

  return (
    <>
      <Button
        loading={isLoading}
        onClick={() => {
          handlePaymentRequest();
        }}
        size={"lg"}
        color={"primary"}
        sx={{
          width: "100%",
          fontWeight: 700,
        }}
      >
        {buttonText}
      </Button>
    </>
  );
}
